import { render, staticRenderFns } from "./modal_add_query.vue?vue&type=template&id=c93e4d36&scoped=true"
import script from "./modal_add_query.vue?vue&type=script&lang=js"
export * from "./modal_add_query.vue?vue&type=script&lang=js"
import style0 from "./modal_add_query.vue?vue&type=style&index=0&id=c93e4d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93e4d36",
  null
  
)

export default component.exports